import { CountryIsoNumber } from '@i18n';
import { AddressFormBuilder } from '../../services/address-form-builder/address-form-builder.service';
import { GBAddressFormBuilder } from '../../services/gb-address-form-builder/gb-address-form-builder.service';
import { IEAddressFormBuilder } from '../../services/ie-address-form-builder/ie-address-form-builder.service';

export function addressFormBuilderFactory(
  countryIsoNumber?: CountryIsoNumber,
): AddressFormBuilder {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return new IEAddressFormBuilder();
    case CountryIsoNumber.GreatBritain:
    default:
      return new GBAddressFormBuilder();
  }
}
